import React from 'react';
import { connect } from 'react-redux';
import Breadcrumbs from '../../../shared/components/breadcrumbs';
import {
  addBreadcrumbT,
  deleteBreadcrumbsT,
  deleteBreadcrumbTitleT,
  setBreadcrumbTitleT
} from "../../../../state/actions/shared/breadcrumbs";

const BreadcrumbsRedux = (props) => (
  <Breadcrumbs
    entityType="landing_page"
    searchEntities={['landing_page']}
    {...props}
  />
);

const mapStateToProps = (state, ownProps) => {
  const {entityId} = ownProps;
  const pageEntities = state.landingPages.landingPage;
  const {editor} = pageEntities;
  const currentPage = editor[entityId]
  const { breadcrumb, breadcrumbTitle, title, updateId } = currentPage;
  return {
    breadcrumb,
    breadcrumbTitle,
    entityId,
    entityTitle: title,
    entityUpdateId: updateId,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {entityId:id} = ownProps;
  return {
    onSetBreadcrumbTitle: (breadcrumbTitle) => dispatch(setBreadcrumbTitleT('landing_page',breadcrumbTitle, id)),
    onDeleteBreadcrumbTitle: () => dispatch(deleteBreadcrumbTitleT('landing_page', id)),
    onSelectBreadcrumb: (breadcrumb) => dispatch(addBreadcrumbT('landing_page', breadcrumb, id)),
    onDeleteBreadcrumb: () => dispatch(deleteBreadcrumbsT('landing_page', id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsRedux);
